import { render, staticRenderFns } from "./RelativesDictionary.vue?vue&type=template&id=fd80592c&lang=pug&"
import script from "./RelativesDictionary.vue?vue&type=script&lang=js&"
export * from "./RelativesDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports